import React from 'react';
import { TrendingUpIcon, BriefcaseIcon, HomeIcon } from 'lucide-react';
export function Benefits() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const benefits = [{
    icon: TrendingUpIcon,
    title: 'MÁS DIRECCIÓN PROFESIONAL',
    description: 'Dejás de preguntarte "¿qué hago ahora?" y empezás a tener un plan claro.'
  }, {
    icon: BriefcaseIcon,
    title: 'MÁS OPORTUNIDADES LABORALES',
    description: 'Aprendés a posicionarte en un mercado donde tu perfil sí tiene valor.'
  }, {
    icon: HomeIcon,
    title: 'MENOS DEPENDENCIA DEL CONSULTORIO',
    description: 'Sumás una nueva vía profesional sin abandonar tu formación.'
  }];
  return <section className="py-12 md:py-20 bg-white" data-id="element-11">
      <div className="max-w-6xl mx-auto px-4" data-id="element-12">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-13">
          UN CAMINO CLARO PARA SALIR DE LA INCERTIDUMBRE
        </h2>
        <p className="text-xl md:text-2xl font-semibold text-center text-[#1a365d] mb-12" data-id="element-14">
          De Psicólogo a RRHH™ (Guía Práctica)
        </p>
        <p className="text-center text-gray-700 mb-12 max-w-3xl mx-auto" data-id="element-15">
          Este sistema fue creado para que dejes de sentirte perdido/a con tu
          carrera y empieces a construir una alternativa profesional concreta.
        </p>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-16">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} onClick={scrollToCompra} className="bg-slate-50 p-8 rounded-xl hover:shadow-lg transition-all cursor-pointer border border-gray-100" data-id="element-17">
                <Icon className="w-12 h-12 text-amber-500 mb-4" data-id="element-18" />
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-19">
                  {benefit.title}
                </h3>
                <p className="text-gray-700" data-id="element-20">{benefit.description}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}